// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ftWhT","label":"styles_label__5hToS"};